import axiosInstance from '../lib/axios';
import type { CreateCasePayload } from '../types/case.types';

export const caseService = {
  searchCases: (params: Record<string, any>) =>
    axiosInstance.get('/cases', { params }),

  getCaseById: (caseId: string) => axiosInstance.get(`/cases/${caseId}`),

  updateCaseHashtags: (caseId: string, hashtags: string[]) =>
    axiosInstance.patch(`/cases/${caseId}/hashtags`, { hashtags }),

  createCase: (payload: CreateCasePayload) =>
    axiosInstance.post('/cases', payload),

  previewCmsNumber: (params: {
    district_id: string | number;
    ps_id: string | number;
    ps_name?: string;
    case_type_code: string;
    fir_number: string;
    year: number | string;
  }) => axiosInstance.get('/cases/cms-number/preview', { params }),

  generateRefNumber: (payload: {
    district_id?: string;
    ps_id?: string;
    district_name?: string;
    ps_name?: string;
    year: number;
    source?: string;
    case_type_code?: string;
    case_type_id?: string | number;
    fir_number?: string;
  }) => axiosInstance.post('/ref-number/generate', payload),
};

export default caseService;


